export const CycleCountStatus = {
    Closed: "Closed",
    Created: "Created",
    Open: "Open",
    Deleted: "Deleted",
}